import React, { useMemo } from 'react';
import ModalHeader from '@components/common/ModalHeader/index';
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cn from 'classnames';
import AddSeatKeyboard from './AddSeatKeyboard';
import { CUSTOM_MESSAGES, LABEL } from '@veriables';

const AddSeatModal = props => {
  const {
    serverAppTheme,
    check,
    isAddSeatModalOpen,
    handleCloseModal,
  } = props;

  const popUpModal = useMemo(() => {
    const modal = {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      pointerEvents: 'auto',
      backgroundColor: serverAppTheme?.popUp_bg,
      backgroundClip: 'padding-box',
      height: '100%',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
    };
    const closeIcon = {
      right: '16px',
      top: props.isLandScape ? '8px' : '14px',
      zIndex: '999',
      color: serverAppTheme?.iconcolor,
    };
    const primaryTextColor = { color: serverAppTheme?.primary_text };

    return { modal, closeIcon, primaryTextColor };
  }, []);
  return (
    <FullWidthModal
      isOpen={isAddSeatModalOpen}
      customClass2={cn('w-100 h-100')}
      style={popUpModal.modal}
      noBackground
    >
      <div
        className="col-12 px-0 h-100 justify-content-center align-items-center position-relative text-center"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            'col-12 px-0 fs_18 d-flex align-items-center justify-content-center fw-600'
          )}
        >
          <ModalHeader
            isTab={!!check?.tab}
            stationName={check?.stationName ?? check?.name}
            tileHeader={LABEL().ADD_SEAT}
            seatNumber={check?.number}
          />
        </div>
        <AddSeatKeyboard
          name="seatNumber"
          type="numericWithBin"
          placeholder={CUSTOM_MESSAGES().ENTER_SEAT_NUMBER}
          isOpen={true}
          customClass="mt-2"
          specialValue=""
          check={check}
          buttonName={LABEL().OCCUPY_SEAT}
          // onSubmit={submitSeatNumber}
          serverAppTheme={serverAppTheme}
          screenType="AddSeats"
          cancelBtnName={LABEL().CANCEL}
          onCancel={() => handleCloseModal()}
          // setErrorPopUp={props.setErrorPopUp}
        />
      </div>
    </FullWidthModal>
  );
};

const mapStateToProps = ({ theme, orders }) => ({
  serverAppTheme: theme.serverAppTheme,
  check: orders.seats,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

const MemoizedAddSeatModal = React.memo(AddSeatModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoizedAddSeatModal);
